import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge16 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の「預託金」とは' fontWeight={700} />
                <p>
                    はじめに、ゴルフ会員権の「預託金」がどういうものなのか、わかりやすく説明します。預託金の仕組みや入会預託金との違いについては
                    <a href='/knowledge/4'>預託金に関して</a>
                    でも詳しく解説していますので、あわせてご参照ください。
                </p>

                <Heading3 title='「預託金」について' />
                <p>
                    「預託金（よたくきん）」は、ゴルフ場を新しく建設する際に新規入会会員から集める預け入れ金のことで、預託金会員制と呼ばれるゴルフ場にて採用されています。
                    <br />
                    預託金は１０～２０年ほどの据え置き期間を経て、所有者へ退会時に返還されるのが一般的です。
                    <br />
                    また、預託金会員制ゴルフ会員権は譲渡出来るため、市場にて株式と同様に第三者への譲渡や親族への譲渡も可能とされています。
                </p>

                <Heading3 title='「預託金」と「入会預託金」の違い' />
                <p>
                    ゴルフ会員権の預託金と近い言葉に「入会預託金」があります。
                    <br />
                    預託金はゴルフ場が開場する前から集められ、ゴルフ場建設をはじめとする開発費や初期費用に充てられるお金です。
                    <br />
                    一方、入会預託金はゴルフ会員権を購入し名義書換をする際に預け入れる費用を指し、退会時に返還される仕組みになっています。
                    <br />
                    コースのメンテナンス費用やクラブハウス修理など運営費用に充てられるのが一般的です。
                    <br />
                    また、市場で売買することが可能な預託会員制のゴルフ会員権は譲渡が可能ですが、入会預託金の譲渡はできません。
                    <br />
                    譲り受けた別の人が新たに入会する場合には別途ゴルフ場に支払わなければなりません。
                    <br />
                    ゴルフ場の建設中に集められる預託金に加えて、別途入会預託金を設定するゴルフ場もあるため、事前に確認しておくと安心でしょう。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の預託金償還問題　なぜトラブルは起こるのか' fontWeight={700} />
                <p>
                    ゴルフ場の預託金に関して、近年様々なトラブルが起きており、中でも預託金償還問題は重要な問題のひとつです。
                    <br />
                    どうしてトラブルが起きてしまうのか、原因も含めて預託金償還問題についてご紹介します。
                </p>

                <Heading3 title='預託金償還問題とは' />
                <p>
                    預託金償還問題とは、ゴルフ場の定めた預託金据え置き期間を満了し、ゴルフ場会員が返還請求を行っても返還出来なくなってしまうという問題です。
                    <br />
                    ゴルフ場の開場前から集めていた預託金は、所定期間を経れば退会時にゴルフ場からの返還を受けられるのですが、ゴルフ場に返せるだけの資金が無いという理由から拒否されて問題に発展するケースが一時期増えました。
                    <br />
                    特にバブル崩壊後は預託金償還問題が増加傾向にありました。
                </p>

                <Heading3 title='預託金の償還でトラブルが起こる理由' />
                <p>
                    では、どうして預託金償還に関するトラブルが起きてしまうのでしょうか。
                    <br />
                    原因としては、会員の減少によるゴルフ場運営状態の悪化、市場における預託金制ゴルフ場会員証券（預託金を証明するためにゴルフ場から発行されるもの）の価値の下落によって、市場での売却額よりも、預託金額返還の方が有利なために償還退会を選択する人が増えたことなどが考えられます。
                    <br />
                    トラブルの例として、具体的な金額を挙げながらご説明します。
                    <br />
                    <br />
                    新規の１８ホール預託金制ゴルフ場Ａのオープンに先駆けて、会員を募集しました。
                    <br />
                    <br />
                    ・一次募集：（一人あたりの預託金）５００万円×１００名＝合計５億円
                    <br />
                    ・二次募集：（一人あたりの預託金）１０００万円×５００名＝合計５０億円
                    <br />
                    ・追加募集：（一人あたりの預託金）２０００万円×５００名＝合計１００億円
                    <br />
                    <br />
                    トータルで１５５億円が集まる計算です。
                    <br />
                    ゴルフ場の建設費用の相場は約１５０億円ですので、差額は５億円になりますが実際には、様々な経費が考えられるためほとんど預託金は残らないでしょう。
                    <br />
                    開場当時にはゴルフ会員権の市場価格は高値をつけやすいため、５０００万円程の価格がついてもおかしくありません。
                    <br />
                    その後、景気が悪化すると需要と供給のバランスが崩れ、会員権相場は大幅に下落する可能性があります。
                    <br />
                    預託金を支払った会員権所有者にとっては、市場で売却するよりも償還してもらう方が有利なため、ゴルフ場に償還を要求するものの、ゴルフ場Ａは手元に資金が残っていないため返還出来ないという状態になります。
                    <br />
                    <br />
                    これが、一般的な預託金償還問題が起きてしまう原因です。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の預託金が償還されない時の対処法' fontWeight={700} />
                <p>
                    預託金償還問題のようなトラブル時には、預託金は基本的には償還されない場合が多いのが現状です。
                    <br />
                    ゴルフ場に資金がない場合は、無い袖は振れないため返還は難しくなります。
                    <br />
                    しかし、そんな状況においても最適な方法は何か、２つご紹介します。
                </p>

                <Heading3 title='交渉して預託金の一部だけでも償還してもらう' />
                <p>
                    会員個人でゴルフ場に交渉し、預託金の返還を訴えても償還は難しい場合が多いため、専門家を通した交渉が望ましいでしょう。
                    <br />
                    専門家に交渉を依頼した結果、預託金の一部だけでも償還出来た事例も過去にあります。
                    <br />
                    会員の代理人として専門家が交渉し、預託金３３０万円の半額の１６５万円、預託金６０万円のうち５０万円を一括返還することで和解できた事例などです。
                    <br />
                    また、預託金の全額あるいは一部を分割返金することで和解できた事例もあります。
                    <br />
                    ゴルフ場側が「経営難で返還出来ない」と返答してきても、専門家に相談することで解決する可能性は高くなるでしょう。
                </p>

                <Heading3 title='ゴルフ会員権の売却' />
                <p>
                    現時点で最も手間がかからない解決方法は、ゴルフ会員権の売却になります。
                    <br />
                    償還に比べるとどうしても損失が大きくなりがちですが、ゴルフ場と交渉する時間がない場合には最適な方法です。
                    <br />
                    過去には知人間の売買も多くみられましたが、手続の複雑化やトラブルへの対処法等から、現在は会員権業者に売却を依頼するのが一般的です。
                    <br />
                    また、売買のプロである専門の会員権業者に依頼する方が有利に売却出来る確率も高まります。
                    <br />
                    会員権の売買を依頼する際には、業者選びも非常に重要です。
                    <br />
                    適切な業者の代表的な条件を挙げますのでチェックしながら検討するようにしましょう。
                    <br />
                    <br />
                    ・やりとりの最初に売却可能金額を提示できる
                    <br />
                    ・迅速・タイムリーな情報を提示できる
                    <br />
                    ・直接購入希望者から依頼をもらっている
                    <br />
                    ・消費税込など金額提示内容がわかりやすい
                    <br />
                    ・実績が高く情報量が多い
                    <br />
                    ・申込書や委任状をいきなり要求しない
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権に関するご相談は住地ゴルフへ' fontWeight={700} />
                <p>
                    ゴルフ会員権の預託金が所定の期間を経ても返還されない場合は、一部だけでも返還が受けられる場合があるので、個人で悩まず専門家に相談することをおすすめします。据置期間満了後に実際に償還請求を行う際の具体的な手続きについては
                    <a href='/knowledge/56'>預託金の償還請求とは</a>
                    で詳しくご紹介しています。
                    <br />
                    また、手間や時間をかけたくない場合は、ゴルフ会員権の売却を専門業者に依頼しましょう。
                    <br />
                    ゴルフ会員権の売買をご検討される場合は、実績豊富な住地ゴルフに一度ご相談ください。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge16;
